import React from "react";
import AppointmentTileGlimmer from "@components/Booking/DoubleBooking/AppointmentTileGlimmer";
import Glimmer from "@components/Glimmer";

const buttonStyle = {
  borderRadius: 100,
};

const AppointmentSelectorGlimmer = () => {
  return (
    <div className="flex flex-col w-[343px] justify-center gap-6">
      <div className="flex flex-row justify-between">
        <AppointmentTileGlimmer />
        <AppointmentTileGlimmer />
      </div>
      <Glimmer height={52} width={"100%"} style={buttonStyle} />
    </div>
  );
};

export default React.memo(AppointmentSelectorGlimmer);
